import { TableCell, TableRow } from "@/components/ui/table";

export const ACTION_STYLE = {
  Ekleme: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Güncelleme": "bg-blue-50 text-blue-700 border-blue-200",
  Silme: "bg-rose-50 text-rose-700 border-rose-200",
  "Gönderim": "bg-amber-50 text-amber-700 border-amber-200",
  "Geri Yükleme": "bg-violet-50 text-violet-700 border-violet-200",
};

export const ChangesRow = ({ changes, colSpan = 6 }) => (
  <TableRow className="bg-slate-50/70 hover:bg-slate-50/70">
    <TableCell colSpan={colSpan} className="py-2">
      <table className="w-full text-xs table-fixed" data-testid="audit-changes-table">
        <thead>
          <tr className="text-slate-500">
            <th className="text-left font-medium py-1 pr-3 w-40">Alan</th>
            <th className="text-left font-medium py-1 pr-3">Eski değer</th>
            <th className="text-left font-medium py-1">Yeni değer</th>
          </tr>
        </thead>
        <tbody>
          {changes.map((c, i) => (
            <tr key={i} className="border-t border-slate-200">
              <td className="py-1 pr-3 font-medium text-slate-700">{c.field}</td>
              <td className="py-1 pr-3 text-rose-700 line-through decoration-rose-300">{c.old}</td>
              <td className="py-1 text-emerald-700">{c.new}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableCell>
  </TableRow>
);
